/** CSV export shared by every CMS table (docs/06 §4: sorting + server pagination + CSV, viewer+). */

export interface CsvColumn<T> {
  header: string;
  value: (row: T) => unknown;
}

/** RFC 4180 field: quote when the value contains a quote, comma, CR or LF. */
export function csvCell(value: unknown): string {
  if (value === null || value === undefined) return '';
  const raw = typeof value === 'object' ? JSON.stringify(value) : String(value);
  return /["\n\r,]/.test(raw) ? `"${raw.replaceAll('"', '""')}"` : raw;
}

export function toCsv<T>(rows: readonly T[], columns: readonly CsvColumn<T>[]): string {
  const lines = [columns.map((c) => csvCell(c.header)).join(',')];
  for (const row of rows) lines.push(columns.map((c) => csvCell(c.value(row))).join(','));
  return lines.join('\r\n');
}

/**
 * Triggers a browser download. A BOM is prepended so Excel opens the accents correctly.
 * No-op outside a DOM (SSR, tests without jsdom).
 */
export function downloadCsv(filename: string, csv: string): void {
  if (typeof document === 'undefined' || typeof URL.createObjectURL !== 'function') return;
  const blob = new Blob([`\uFEFF${csv}`], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}
